import { EmployeeSettingsService } from './EmployeeSettingsService';
import { logger } from 'src/logger';

export class HuddleStatsService {
  /** Get total meetings scheduled from the atomic counter. */
  static async getMeetingsScheduledCount(): Promise<number> {
    try {
      return await EmployeeSettingsService.getMeetingCount();
    } catch (error) {
      logger.error('[HuddleStatsService] Failed to fetch meeting count', { error });
      return 0;
    }
  }
}
